import { useState } from "react";
import { Outlet } from "react-router-dom";
import { AppSidebar } from "./Sidebar";
import { Header } from "./Header";
import { MobileNav } from "./MobileNav";
import { SidebarProvider, SidebarInset, useSidebar } from "@/components/ui/sidebar";
import { useIsMobile } from "@/hooks/use-mobile";
import { useMobileNav } from "@/contexts/MobileNavContext";

function LayoutContent({
  searchQuery,
  setSearchQuery
}: {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}) {
  const { state } = useSidebar();
  const isMobile = useIsMobile();
  const { showMobileNav } = useMobileNav();

  return (
    <SidebarInset
      className="flex-1 flex flex-col w-full max-w-full overflow-x-hidden transition-[margin-left] duration-200 ease-linear"
      style={{
        marginLeft: !isMobile ? (state === "expanded" ? "var(--sidebar-width)" : "var(--sidebar-width-icon)") : "0"
      } as React.CSSProperties}
    >
      <Header
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      <main 
        className="flex-1 p-6 pb-6 w-full max-w-full overflow-x-hidden"
        style={isMobile && showMobileNav ? {
          paddingBottom: `calc(1.5rem + 4rem + env(safe-area-inset-bottom, 0px))`
        } : undefined}
      >
        <Outlet />
      </main>
    </SidebarInset>
  );
}

export function AppLayout() {
  const [searchQuery, setSearchQuery] = useState("");
  const { showMobileNav } = useMobileNav();

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full max-w-full overflow-x-hidden">
        <AppSidebar />
        <LayoutContent
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </div>
      {showMobileNav && <MobileNav />}
    </SidebarProvider>
  );
}
